/**
 * The hub, as the menu sees it.
 *
 * Copy and a loader, and nothing else. Every static import here lands in the chunk that draws the
 * main menu, so this file reaches only data: the station count, off the same registry the room is
 * built from, so the chip cannot drift from what is actually standing in there. The room, the sim
 * and the UI arrive through `load`, on the press that asks for them.
 *
 * No backdrop. The menu's scenery is the range's, and a second scene behind the cards would be a
 * whole second chunk downloaded for a picture nobody asked for.
 */

import { HUB_STATIONS } from '@/modes/hub/sim/stations/hubStationRegistry';
import {
  HUB_FACT_PLAYERS,
  HUB_FACT_PLAYERS_VALUE,
  HUB_FACT_STATIONS,
} from '@/modes/hub/text/hubCardText';
import type { GameMode, ModeCode } from '@/modes/modeContract';

export const HUB: GameMode = {
  id: 'hub',
  title: 'The hub',
  tagline: 'Somewhere to stand when nothing is shooting at you',
  facts: [
    { label: HUB_FACT_STATIONS, value: String(HUB_STATIONS.length) },
    { label: HUB_FACT_PLAYERS, value: HUB_FACT_PLAYERS_VALUE },
  ],
  controls: ['pointerLock', 'touch'],
  // One room, one player. `hubState` seats exactly HOST_PLAYER and puts nothing on the wire, so
  // hosting this would seat guests into private copies of the same room. #214 is what makes it
  // 'coop', and it is a one word edit here when it lands.
  party: 'solo',
  hasBackdrop: false,
  async load(): Promise<ModeCode> {
    const app = await import('@/modes/hub/hubApp');
    return { launch: app.startHub, createBackdrop: null };
  },
};
